/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './table-layout.component';
export * from './core-ui-table-layout.module';
